import { MODES } from './constants';

export function parseCalendarDateString(str) {
  const raw = String(str || '').trim();
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(raw);
  if (!m) return null;
  const y = Number(m[1]);
  const mo = Number(m[2]) - 1;
  const d = Number(m[3]);
  const dt = new Date(Date.UTC(y, mo, d));
  if (dt.getUTCFullYear() !== y || dt.getUTCMonth() !== mo || dt.getUTCDate() !== d) return null;
  return dt;
}

export function getNthWeekdayInMonth(date) {
  const weekday = date.getUTCDay();
  const day = date.getUTCDate();
  let count = 0;
  for (let d = 1; d <= day; d++) {
    const probe = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), d));
    if (probe.getUTCDay() === weekday) count++;
  }
  const lastDay = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + 1, 0)).getUTCDate();
  let lastCount = 0;
  for (let d = 1; d <= lastDay; d++) {
    const probe = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), d));
    if (probe.getUTCDay() === weekday) lastCount++;
  }
  if (count === lastCount) return 'last';
  return count;
}

export function deriveCalendarSubRuleFromAnchor(anchorDate) {
  const d = typeof anchorDate === 'string' ? parseCalendarDateString(anchorDate) : anchorDate;
  if (!d || Number.isNaN(d.getTime())) {
    return { mode: MODES[0], dayOfMonth: 1, nth: 1, weekday: 1 };
  }
  return {
    mode: 'dayOfMonth',
    dayOfMonth: d.getUTCDate(),
    nth: getNthWeekdayInMonth(d),
    weekday: d.getUTCDay(),
  };
}
